import type { Action } from "../../actions/types";
import { CHANNEL_TO_REDUCER_MAP, REFERRAL_CHANNELS } from "./index";

export type StoreState = {
  appleWallet: boolean;
  googleWallet: boolean;
  qr: boolean;
  referral: boolean;
};

export const initialState = {
  appleWallet: false,
  googleWallet: false,
  qr: false,
  referral: false,
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_REFERRAL_FAILURE":
      if (action.data && REFERRAL_CHANNELS.includes(action.data.channel)) {
        return {
          ...state,
          [CHANNEL_TO_REDUCER_MAP[action.data.channel]]: true,
        };
      } else {
        return { ...state, referral: true };
      }

    case "GET_REFERRAL_REQUEST":
    case "GET_REFERRAL_SUCCESS":
      if (action.data && REFERRAL_CHANNELS.includes(action.data.channel)) {
        return {
          ...state,
          [CHANNEL_TO_REDUCER_MAP[action.data.channel]]: false,
        };
      } else {
        return { ...state, referral: false };
      }

    default:
      return state;
  }
}
